import React, { Component } from 'react';
import './FlipCounter.scss';
export default class FlipCounter extends Component {
    constructor(props) {
        super(props);
        
        const firstNum = props.eurovisionTotalDays + 10;
        const oldNum = firstNum + 1;
        const firstNumStr = firstNum.toString();
        const oldNumStr = oldNum.toString();
        const nums = [];
        for (let i = 0; i < firstNumStr.length; i++) {
            nums.push({
                newNum: +firstNumStr.charAt(i),
                oldNum: +oldNumStr.charAt(i),
                change: true
            })

        }
        this.state = {
            firstNum: firstNum,
            nums: nums
        }
    }

    componentDidMount() {
        if (this.props.eurovisionTotalDays > 0) {
            this.timerID = setInterval(
                () => this.tick(),
                200
            );
        }
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    tick() {
        if (this.state.firstNum < 0) {
            clearInterval(this.timerID);
            return;
        }
        const newNum = this.state.firstNum;
        const oldNum = newNum + 1;
        const sNumber = newNum.toString();
        const nums = [];
        for (var i = 0, len = sNumber.length; i < len; i += 1) {
            nums.push({
                newNum: +sNumber.charAt(i),
                oldNum: +oldNum.toString().charAt(i),
                change: sNumber.charAt(i) !== oldNum.toString().charAt(i) ? !this.state.nums[i].change : false
            })
        }

        if (newNum >= this.props.eurovisionTotalDays) {
            this.setState(prevState => ({
                nums,
                firstNum: prevState.firstNum - 1
            }));
        }
    }

    render() {
        return (
            <div className="flip-counter-container">
                {this.state.nums.map((item, index) => {
                    const { newNum, oldNum, change } = item;
                    const animation1 = change ? 'fold' : 'unfold';
                    const animation2 = !change ? 'fold' : 'unfold';
                    const number1 = change ? oldNum : newNum;
                    const number2 = !change ? oldNum : newNum;
                    return (<div key={index} className={'flipCounter'}>
                        <div className={'upperCard'}>
                            <span>{newNum}</span>
                        </div>
                        <div className={'lowerCard'}>
                            <span>{oldNum}</span>
                        </div>
                        <div className={`flipCard first ${animation1}`}>
                            <span>{number1}</span>
                        </div>
                        <div className={`flipCard second ${animation2}`}>
                            <span>{number2}</span>
                        </div>
                    </div>
                    )
                })}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/FlipCounter/FlipCounter.js